
import PaymentStatusWidget from '@/core/components/PaymentStatusWidget.vue';
import { LoanDetails } from '@/loan/types/loan-details';
import { MONTH_MAP } from '@/util/constants/month-map';
import { UtilHelper } from '@/util/helper';
import { Component, Prop, Vue } from 'vue-property-decorator';

const TEST_ID = 'Kloans-LoanNotYetPaidWidget';

@Component({
	components: {
		PaymentStatusWidget,
	},
})
export default class LoanNotYetPaidWidget extends Vue {
	public TEST_ID = TEST_ID;

	public formatDollar = UtilHelper.formatDollar;

	@Prop()
	public loanDetails!: LoanDetails;

	get daysUntilDue(): number {
		const dueDate = new Date(this.loanDetails?.general?.paymentDueDate);
		const today = new Date();

		return UtilHelper.getTotalDaysBetweenDates(today, dueDate);
	}

	get dueDate(): string {
		const date = new Date(this.loanDetails?.general?.paymentDueDate);
		const dayOfMonth = date.getDate();
		const monthNum = date.getMonth() + 1;
		const month = MONTH_MAP.get(monthNum);

		return `${month} ${dayOfMonth}`;
	}

	get paymentDueAmount(): string {
		return this.loanDetails?.general?.paymentDueAmount ?? String(0);
	}
}
